import useTranslate from 'modules/local/useTranslate'
import React, {useContext, useEffect, useMemo, useState} from 'react'
import {getFullAddress, NullAsDefault} from 'views/Shared'
import {bindQueryParam} from "../../functions/routerHelper";
import useAsyncAction from "../../../../modules/asyncCache/useAsyncAction";
import {
    user_checkin_editUserCheckin_Api,
    user_checkin_getMyCheckins_Api,
    user_checkin_removeUserCheckin_Api,
    user_checkin_userCheckin_Api,
    user_checkin_userCheckinSaveOnly_Api
} from "../../../../apis/event";
import {NotificationActionTypes, successNotify} from "../../factory/createNotification";
import {notifyOnError} from "../../factory/createErrorEvent";
import _ from "lodash";
import {FeedProvider} from "../../../../components/Feed/FeedProvider";
import {allActions} from "../../../../components/Feed/TimeLineFeed";
import FeedContext from "../../../../components/Feed/FeedContext";
import {App, Avatar, Image, Modal} from "antd";
import {BsCheckCircleFill, BsPersonFill} from "react-icons/bs";
import getAvatar from "../../../../helpers/getAvatar";
import getAliasName from "../../../../helpers/getAliasName";
import getTitle from "../../../../helpers/getTitle";
import createConfirmDialog from "../../factory/createConfirmDialog";
import {PiWarningCircle} from "react-icons/pi";
import {getType} from "../../../../apis/model/base";
import {ImagePlaceholder} from "../../../../conts/imageBase64";
import {showErrorDialog} from "../../factory/createErrorDialog";
import {useHistory} from "../../../../modules/navigation/useRouter";
import {GoLocation} from "react-icons/go";
import dayjs from "dayjs";
import {LoginContext} from "../../../../components/LoginContext";
import {ItemInformation} from "../../../../components/common/ItemInformation";


export const useCheckinApi = ({
                                  item,
                                  notifyListeners = {
                                      onSuccessCheckedInSaveOnly: undefined,
                                      onErrorCheckedInSaveOnly: undefined,
                                      onSuccessCheckedIn: undefined,
                                      onErrorCheckedIn: undefined,
                                      onSuccessRemoveCheckedIn: undefined,
                                      onErrorRemoveCheckedIn: undefined,
                                      onSuccessEditCheckedIn: undefined,
                                      onErrorEditCheckedIn: undefined
                                  },
                              }) => {
    const t = useTranslate()
    const history = useHistory();
    const {modal} = App.useApp();
    const [checkedInData, setCheckedInData] = useState(null)
    const [savedCheckinData, setSavedCheckinData] = useState(null)
    const [myCheckIns, setMyCheckIns] = useState([])
    const login = useContext(LoginContext)

    const {
        onSuccessCheckedInSaveOnly = NullAsDefault,
        onErrorCheckedInSaveOnly = NullAsDefault,
        onSuccessCheckedIn = NullAsDefault,
        onErrorCheckedIn = NullAsDefault,
        onSuccessRemoveCheckedIn = NullAsDefault,
        onErrorRemoveCheckedIn = NullAsDefault,
        onSuccessEditCheckedIn = NullAsDefault,
        onErrorEditCheckedIn = NullAsDefault,
    } = notifyListeners ?? {}
    const onError = notifyOnError(t)


    const {handleAsyncAction: getMyCheckins} = useAsyncAction({
        apiInfo: user_checkin_getMyCheckins_Api,
        onSuccess: (result, data) => {
            const dataItems = _.get(data, 'response.data.data', [])
            setMyCheckIns(dataItems)
        },
    })


    useEffect(() => {
        if (!!login?.id) {
            setTimeout(function () {
                getMyCheckins();
            }, 1000);
        }
    }, [])

    const todayCheckin = myCheckIns.find(i => i?.owner?.id === checkedInData?.owner?.id &&
        new Date(i.checkin_time).toDateString() === new Date().toDateString()
    )

    const hasCheckedInToday = !!todayCheckin
    const checkinTime = todayCheckin?.checkin_time || null

    const checkedInModal = useMemo(() => {
        const owner = !!item?.owner ? item?.owner : item;

        if (!!!checkedInData) return null;

        return (
            <Modal
                className="custom-modal"
                footer={null}
                onCancel={() => {
                    setCheckedInData(null)
                }}
                open={!!checkedInData}
                destroyOnHidden={true}>
                <div className="flex flex-col gap-4">
                    <div className="flex items-center gap-2">
                        <span
                            style={{width: 30, height: 30}}
                            className="flex flex-center flex-shrink-0 rounded-full bg-green-50 text-green-600">
                            <BsCheckCircleFill size={16}/>
                        </span>
                        <span className="font-bold text-base text-green-600 tracking-wide leading-tight">
                            {t('You have successfully checked in')}
                        </span>
                    </div>

                    <div className="flex flex-col gap-3 p-3 background-50 border border-color-50 rounded-xl">
                        <div className="flex items-center gap-2">
                            <Avatar
                                icon={<BsPersonFill size={16} className="text-color-500"/>}
                                src={getAvatar(item?.user)}
                                size={32}
                                className="flex-shrink-0 background-200"
                            />
                            <span className="flex-1 min-w-0 font-bold text-sm text-color-000 tracking-wide truncate">
                                {getAliasName(item?.user, 'patron_saint')} {' '}
                                {getTitle(item?.user)}
                            </span>
                        </div>
                        {hasCheckedInToday ? (
                            <div className="flex flex-col items-center gap-2 py-3 px-3 bg-green-50 rounded-lg">
                                <span className="text-xs text-green-600 tracking-wide">
                                    {t('you checked in at this location today at')}
                                </span>
                                <span
                                    style={{fontVariantNumeric: 'tabular-nums'}}
                                    className="font-bold text-3xl text-green-700 leading-none">
                                    {dayjs(checkinTime).format('HH:mm')}
                                </span>
                                {getTitle(owner) && (
                                    <div className="mt-1 pt-2 w-full border-t border-green-100 flex items-center justify-center gap-1.5 font-bold text-sm text-green-800 tracking-wide">
                                        <GoLocation size={13} className="flex-shrink-0"/>
                                        {getTitle(owner)}
                                    </div>
                                )}
                            </div>
                        ) : (
                            <div className="py-2 text-center text-sm text-color-300 italic tracking-wider">
                                {t('you have successfully checked in at this location')}
                            </div>
                        )}
                    </div>

                    {(!hasCheckedInToday && getTitle(owner)) && (
                        <div className="flex flex-col gap-1.5">
                            <span className="text-2xs font-bold text-color-300 uppercase tracking-widest">
                                {t('locations')}
                            </span>
                            <div className="flex items-center gap-1.5 font-bold text-sm text-color-000 tracking-wide">
                                <GoLocation size={13} className="text-primary flex-shrink-0"/>
                                {getTitle(owner)}
                            </div>
                            <ItemInformation
                                label="address"
                                value={getFullAddress(owner)}
                                className="text-xs italic tracking-wider"
                            />
                            {owner?.photo && (
                                <Image
                                    src={owner?.photo || ImagePlaceholder}
                                    fallback={ImagePlaceholder}
                                    style={{width: '100%', minHeight: 80, maxHeight: 120}}
                                    className="mt-1 flex flex-col flex-center background-200 rounded-lg object-cover"
                                    wrapperClassName="rounded-lg"
                                    preview={false}
                                />
                            )}
                        </div>
                    )}

                    <div className="pt-3 border-t border-color-50 flex items-center justify-between gap-3">
                        <button
                            type="button"
                            style={{padding: '8px 16px', borderRadius: 10}}
                            className="font-semibold text-sm text-blue-600 bg-blue-50 hover:bg-blue-100 border-0 cursor-pointer transition-all"
                            onClick={() => {history.push("/mass-times?tab=journal")}}>
                            {t("go to check-in list")}
                        </button>
                        <FeedProvider
                            item={{ ...checkedInData }}
                            defaultActions={allActions}>
                            <FeedContext.Consumer>
                                {({handleClick, shareUrl}) => (
                                    <span
                                        className="font-semibold text-sm text-color-300 hover:text-primary cursor-pointer"
                                        onClick={() => {handleClick('quote')}}>
                                        {t("share")}
                                    </span>
                                )}
                            </FeedContext.Consumer>
                        </FeedProvider>
                    </div>
                </div>
            </Modal>
        )
    }, [checkedInData])

    const savedCheckinModal = useMemo(() => {
        if (!!!savedCheckinData) return null;

        const owner = !!savedCheckinData?.owner ? savedCheckinData?.owner : savedCheckinData;

        return (
            <Modal
                className="custom-modal"
                footer={null}
                onCancel={() => {
                    setSavedCheckinData(null)
                }}
                open={!!savedCheckinData}
                destroyOnHidden={true}>
                <div className="flex flex-col gap-4">
                    <div className="flex items-center gap-2">
                        <span
                            style={{width: 30, height: 30}}
                            className="flex flex-center flex-shrink-0 rounded-full bg-green-50 text-green-600">
                            <BsCheckCircleFill size={16}/>
                        </span>
                        <span className="font-bold text-base text-green-600 tracking-wide leading-tight">
                            {t('Save successful')}
                        </span>
                    </div>

                    <div className="flex flex-col gap-3 p-3 background-50 border border-color-50 rounded-xl">
                        <div className="text-sm text-color-200 tracking-wide">
                            {t('Your visit to this place has been saved successfully.')}
                        </div>

                        {getTitle(owner) && (
                            <div className="flex items-center gap-1.5 font-bold text-sm text-color-000 tracking-wide">
                                <GoLocation size={13} className="text-primary flex-shrink-0"/>
                                {getTitle(owner)}
                            </div>
                        )}

                        {owner?.photo && (
                            <Image
                                src={owner?.photo || ImagePlaceholder}
                                fallback={ImagePlaceholder}
                                style={{width: '100%', minHeight: 80, maxHeight: 120}}
                                className="flex flex-col flex-center background-200 rounded-lg object-cover"
                                wrapperClassName="rounded-lg"
                                preview={false}
                            />
                        )}
                    </div>

                    <div className="text-center text-sm text-color-300 italic tracking-wider">
                        {t('would you like to review the pilgrimage stops')}
                    </div>

                    <div className="pt-3 border-t border-color-50 flex items-center justify-between gap-3">
                        <button
                            type="button"
                            style={{padding: '8px 16px', borderRadius: 10, minHeight: 44}}
                            className="font-semibold text-sm text-color-300 hover:text-color-000 background-100 hover:background-200 border-0 cursor-pointer transition-all"
                            onClick={() => {setSavedCheckinData(null)}}>
                            {t('got it')}
                        </button>
                        <button
                            type="button"
                            style={{padding: '8px 20px', borderRadius: 10, minHeight: 44}}
                            className="flex-1 font-semibold text-sm text-white bg-primary hover:opacity-90 border-0 cursor-pointer transition-all"
                            onClick={() => {
                                setSavedCheckinData(null)
                                history.push("/mass-times?tab=journal")
                            }}>
                            {t("go to check-in list")}
                        </button>
                    </div>
                </div>
            </Modal>
        )
    }, [savedCheckinData])

    const {handleAsyncAction: onCheckInSaveOnly, ...asyncCheckingInSaveOnly} = useAsyncAction({
        onError: (error, errorObj) => {
            showErrorDialog(t)({
                error, errorObj,
                closable: true,
                maskClosable: true,
                okText: t('got it'),
                cancelText: t('close'),
            })

            onErrorCheckedInSaveOnly(error, errorObj)
        },
        query: bindQueryParam({}),
        apiInfo: user_checkin_userCheckinSaveOnly_Api,
        onSuccess: (result, data) => {
            const item = _.get(data, 'response.data') ?? {}
            setSavedCheckinData(item)

            onSuccessCheckedInSaveOnly(result, data)
        },
    })

    const {handleAsyncAction: onCheckIn, ...asyncCheckingIn} = useAsyncAction({
        onError: (error, errorObj) => {
            createConfirmDialog({
                modal,
                className: 'custom-modal text-base',
                translate: t,
                icon: <PiWarningCircle className="anticon"/>,
                title: t('check-in unsuccessful'),
                message: (
                    <div className="flex flex-col gap-3">
                        <div>{errorObj?.error}</div>
                        <div style={{fontStyle: 'normal'}} className="mb-3 text-color-100 tracking-wider">
                            {t("Would you like to save this place to check in again on your next visit")}
                        </div>
                    </div>
                ),
                okText: t('yes'),
                cancelText: t('ignore'),
                onOk: () => {
                    onCheckInSaveOnly({}, {
                        owner_type: getType(item),
                        owner_id: item?.id
                    })
                },
                okButtonProps: {
                    type: 'primary',
                    className: 'button-rounded-lg no-border',
                },
                cancelButtonProps: {
                    type: 'default',
                    className: 'button-rounded-lg no-border text-color-300',
                },
            })
        },
        query: bindQueryParam({}),
        apiInfo: user_checkin_userCheckin_Api,
        onSuccess: (result, data) => {
            const item = _.get(data, 'response.data') ?? {}
            setCheckedInData(item)

            onSuccessCheckedIn(result, data)
        },
    })

    const {handleAsyncAction: onRemoveCheckIn, ...asyncRemoveCheckingIn} = useAsyncAction({
        onError: (result, data) => {
            onErrorRemoveCheckedIn(result, data)
        },
        query: bindQueryParam({}),
        apiInfo: user_checkin_removeUserCheckin_Api,
        onSuccess: (result, data) => {
            onSuccessRemoveCheckedIn(result, data)
        },
    })

    const {handleAsyncAction: onEditCheckIn, ...asyncEditCheckingIn} = useAsyncAction({
        onError,
        query: bindQueryParam({}),
        apiInfo: user_checkin_editUserCheckin_Api,
        onSuccess: (result, data) => {
            successNotify(NotificationActionTypes.UPDATE, t)
            onSuccessEditCheckedIn(result, data)
        },
    })

    return {
        checkedInModal,
        savedCheckinModal,
        onCheckInSaveOnly, asyncCheckingInSaveOnly,
        onCheckIn, asyncCheckingIn,
        onRemoveCheckIn, asyncRemoveCheckingIn,
        onEditCheckIn, asyncEditCheckingIn
    }
}



